export type Tone = 'muted' | 'secondary' | 'warning' | 'success' | 'danger'

/** Status wording comes from the server; only its visual tone is selected here. */
export const STATUS_TONE: Record<string, Tone> = {
  DRAFT: 'muted',
  IN_REVIEW: 'secondary',
  CHANGES_REQUESTED: 'warning',
  APPROVED: 'success',
  SENT_TO_PRINT: 'secondary',
  PRINTED: 'success',
}
